<div class="container">
    <div class="header">
        <span *ngFor="let youthWorker of messageData?.participants | slice:1;let i = index;">
            <!-- <img *ngIf="youthWorker?.userId != studentId" src="../../../../assets/account-circle.svg" class="avatar"/> -->
            <img 
                *ngIf="youthWorker?.avatarBase64 != null" 
                [src]="'data:image/jpg;base64,'+ youthWorker.avatarBase64 | safeHtml" 
                [class]="{'avatar': i == 1, 'secondary-avatar': i == 0}"
            />
        </span>
        <!-- <img *ngIf="activeYouthWorkerData?.avatarBase64" [src]="'data:image/jpg;base64,'+ activeYouthWorkerData.avatarBase64 | safeHtml" class="secondary-avatar"/>
        <img *ngIf="activeYouthWorkerData?.avatarBase64" [src]="'data:image/jpg;base64,'+ activeYouthWorkerData.avatarBase64 | safeHtml" class="avatar"/> -->
        <span *ngIf="activeYouthWorkerData" class="youth-worker-name">{{ activeYouthWorkerData.name }}</span>
    </div>
    
    <div class="message-box">
        <div *ngFor="let messages of messageData?.messages">
            <app-chat-message 
                [participantId]="messages.userId"
                [studentId]="studentId" 
                [messageData]="messages" 
                [studentAvatar]="studentAvatar"
            >
            </app-chat-message>
        </div>
    </div>
    
    <mat-divider class="divider"></mat-divider>

    <form [formGroup]="messageForm" class="message-form-group">
        <mat-form-field class="form-field">
            <label for="message-input"></label>
            <textarea 
                class="text-input" 
                id="message-input" 
                matInput 
                placeholder="{{'Please enter your message...' | translate}}"
                formControlName="messageInput"
            >
            
            </textarea>
        </mat-form-field>
        <div matSuffix class="message-icons">
            <button mat-icon-button><mat-icon (click)="attachFile.click()">attach_file</mat-icon></button>
            <input hidden #attachFile type="file" (change)="onAttachFile($event)"/>
            <button mat-icon-button [disabled]="!messageForm.valid"><mat-icon (click)="messageForm.valid ? onSubmit() : null ">send</mat-icon></button>
        </div>
    </form>
</div>

